import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectIsOpened } from 'store/widget'

export const useToggleWidget = () => {
  const isOpened = useSelector(selectIsOpened)

  useEffect(() => {
    window.parent.postMessage(
      {
        type: 'toggleWidget',
        payload: isOpened,
      },
      '*',
    )
  }, [])

  return useMemo(() => isOpened, [isOpened])
}
